// Upstream reports whether the user is signed in, and the app's version, to Telegram's own domains by loading
// a script from each of them. Jaryan does not send its users' browsers there, so these do nothing; they stay
// exported so the upstream callers are unchanged
const WEBSYNC_KEY = 'tgme_sync';

export function forceWebsync(authed: boolean): Promise<void> {
  return Promise.resolve();
}

export function stopWebsync() {}

export function startWebsync() {}

export function clearWebsync() {
  localStorage.removeItem(WEBSYNC_KEY);
}
